module.exports = __webpack_public_path__ + "media/images/rides/icon3-cdd6d0c53b851d843954607623500de9.svg";